import { Route } from '@angular/router';
import { InitialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off

export const appRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'main',
    },
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'main',
    },
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routing').then((m) => m.authConfirmationRequiredRoutes),
            },
            {
                path: 'forgot-password',
                loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routing').then((m) => m.authForgotPasswordRoutes),
            },
            {
                path: 'reset-password',
                loadChildren: () => import('app/modules/auth/reset-password/reset-password.routing').then((m) => m.authResetPasswordRoutes),
            },
            {
                path: 'sign-in',
                loadChildren: () => import('app/modules/auth/sign-in/sign-in.routing').then((m) => m.authSignInRoutes),
            },
            {
                path: 'sign-up',
                loadChildren: () => import('app/modules/auth/sign-up/sign-up.routing').then((m) => m.authSignupRoutes),
            },
            {
                path: 'mfa-setup',
                loadChildren: () => import('app/modules/auth/mfa-setup/mfa-setup.routing').then((m) => m.mfaSetupRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () => import('app/modules/auth/sign-out/sign-out.routing'),
            },
            {
                path: 'unlock-session',
                loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routing').then((m) => m.authUnlockSessionRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'authorize',
                loadChildren: () => import('app/modules/auth/authorize/authorize.routing').then((m) => m.authorizeRoutes),
            },
        ],
    },
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'home',
                loadChildren: () => import('app/modules/landing/home/home.component').then((m) => m.LandingHomeComponent),
            },
            {
                path: 'support/cloudbeds-integration',
                loadComponent: () => import('app/modules/support/cloudbeds-support/cloudbeds-support.component').then((m) => m.CloudbedsSupportComponent),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'main',
                loadChildren: () => import('app/modules/admin/main/main.routing').then((m) => m.mainRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'permissions',
                loadChildren: () => import('app/modules/admin/permissions/permissions.routing').then((m) => m.permissionRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'cameras',
                loadChildren: () => import('app/modules/admin/cameras/cameras.routing').then((m) => m.camerasRoutes),
            },
            {
                path: 'recording-exports',
                loadChildren: () => import('app/modules/admin/recording-exports/recording-exports.routing').then((m) => m.recordingExportsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'ai-rules',
                loadChildren: () => import('app/modules/admin/ai_rules/ai_rules.routing').then((m) => m.aiRulesRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'test-error',
                loadChildren: () => import('app/modules/admin/test_error/test-error.routing').then((m) => m.TestRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'devices',
                loadChildren: () => import('app/modules/admin/devices/devices.routing').then((m) => m.deviceRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'tasks-templates',
                loadChildren: () => import('app/modules/admin/tasks_templates/tasks_templates.routing').then((m) => m.tasksTemplatesRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'help_desks',
                loadChildren: () => import('app/modules/admin/help_desks/help-desk.routing').then((m) => m.help_deskRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'users',
                loadChildren: () => import('app/modules/admin/users/users.routing').then((m) => m.userRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'access',
                loadChildren: () => import('app/modules/client/access/access.routing').then((m) => m.entryRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'common_spaces',
                loadChildren: () => import('app/modules/client/common_spaces/common_spaces.routing').then((m) => m.common_spaceRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'communities',
                loadChildren: () => import('app/modules/admin/communities/communities.routing').then((m) => m.communitiesRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'communities-payments',
                loadChildren: () => import('app/modules/admin/communities_payments/communities_payments.routing').then((m) => m.communities_paymentsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'real_estates',
                loadChildren: () => import('app/modules/admin/real_estates/real-estates.routing').then((m) => m.real_estateRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'products',
                loadChildren: () => import('app/modules/admin/products/products.routing').then((m) => m.productsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'categories',
                loadChildren: () => import('app/modules/admin/categories/categories.routing').then((m) => m.categoriesRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'groups',
                loadChildren: () => import('app/modules/client/groups/groups.routing').then((m) => m.groupRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'records',
                loadChildren: () => import('app/modules/client/records/records.routing').then((m) => m.recordRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'control-center',
                loadChildren: () => import('app/modules/client/control-center/control-center.routing').then((m) => m.controlCenterRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'schedules',
                loadChildren: () => import('app/modules/client/schedules/schedules.routing').then((m) => m.scheduleRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'floors',
                loadChildren: () => import('app/modules/client/floors/floors.routing').then((m) => m.floorsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'rooms',
                loadChildren: () => import('app/modules/client/rooms/rooms.routing').then((m) => m.roomRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'doors',
                loadChildren: () => import('app/modules/client/doors/doors.routing').then((m) => m.doorRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'live',
                loadChildren: () => import('app/modules/client/live/live.routing').then((m) => m.LiveRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'e-lockers',
                loadChildren: () => import('app/modules/client/e_lockers/e_lockers.routing').then((m) => m.e_lockerRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'units',
                loadChildren: () => import('app/modules/client/units/units.routing').then((m) => m.unitsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'user_profile',
                loadChildren: () => import('app/modules/admin/user_profile/user_profile.routing').then((m) => m.user_profileRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'settings',
                loadChildren: () => import('app/modules/admin/settings/settings.routing').then((m) => m.settingsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'residents',
                loadChildren: () => import('app/modules/client/residents/residents.routing').then((m) => m.residentsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'faqs',
                loadChildren: () => import('app/modules/client/faqs/faqs.routing').then((m) => m.faqRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'quotes',
                loadChildren: () => import('app/modules/admin/quotes/quotes.routing').then((m) => m.quotesRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'common_expenses',
                loadChildren: () => import('app/modules/client/common_expenses/common_expenses.routing').then((m) => m.common_expenseRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'rooms_charges',
                loadChildren: () => import('app/modules/client/rooms_charges/rooms_charges.routing').then((m) => m.room_chargeRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'demos',
                loadChildren: () => import('app/modules/client/demos/demos.routing').then((m) => m.demosRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'companies',
                loadChildren: () => import('app/modules/admin/companies/companies.routing').then((m) => m.companiesRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'notifications',
                loadChildren: () => import('app/modules/admin/notifications/notifications.routing').then((m) => m.notificationsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'books-logs',
                loadChildren: () => import('app/modules/admin/books-logs/books-logs.routing').then((m) => m.booksLogsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'tasks',
                loadChildren: () => import('app/modules/admin/tasks/tasks.routing').then((m) => m.tasksRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'shifts',
                loadChildren: () => import('app/modules/admin/shifts/shifts.routing').then((m) => m.shiftsRoutes),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'concierges',
                loadChildren: () => import('app/modules/admin/concierges/concierges.routing').then((m) => m.conciergesRoutes),
            },
        ],
    },
];
